import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environment/environment';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionServiceService {

  baseurl = environment.api_client_service;

  constructor(private http: HttpClient) { }

  get_active_subscription(token: string): Observable<any> {
    const headers = new HttpHeaders({
      "Authorization": `bearer ${token}`
    })
    return this.http.get(this.baseurl + `/client/current-order`, {headers});
  }

  get_all_orders(token: string): Observable<any> {
    const headers = new HttpHeaders({
      "Authorization": `bearer ${token}`
    })
    return this.http.get(this.baseurl + `/client/orders`, {headers});
  }

  remove_subscription(token: string, orderId: string) {
    const headers = new HttpHeaders({
      "Authorization": `bearer ${token}`
    })
    return this.http.patch(this.baseurl + `/client/unsubscription/${orderId}`, {}, {headers});
  }
}
